import React, { useContext, useEffect, useState } from "react";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import moment from "jalali-moment";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import FileKeysContext from "../../../../context/fileKeysContext";
import ExpertVideosContext from "../../../../context/expertVideosContext";
import {
  cancelModifiedVideoUpdate,
  editExpertVideo,
  editRejectedExpertVideo,
} from "../../../../service/api";
import { uiHelper } from "../../../../helpers/uihelper";
import ExpertVideoModal from "../modal/ExpertVideoModal";
import { CustomModal } from "../../../../components/CustomModal";
import { CloseOutlined, EditOutlined } from "@ant-design/icons";
import { Button } from "antd";
import UploadingProcessContext from "../../../../context/uploadingProcessContext";

function ExpertVideosSwiper({ video }) {
  const [videoData, setVideoData] = useState(null);
  const [videoLink, setVideoLink] = useState();
  const [openModal, setOpenModal] = useState(false);
  const [modalSize, setModalSize] = useState("");
  let w = document.documentElement.clientWidth || window.innerWidth;
  useEffect(() => {
    if (w > 640) {
      setModalSize("52vw");
    }
    if (w <= 640) {
      setModalSize("100vw");
    }
  }, [w]);
  const queryCilent = useQueryClient();
  const { newOldKeys, newOldVideoCoverKey, resetFileKeysContext } =
    useContext(FileKeysContext);
  const {
    title,
    description,
    tag,
    categoriesIds,
    keywords,
    resetExpertVideosContext,
  } = useContext(ExpertVideosContext);
  const { resetUploadingProcessContext } = useContext(UploadingProcessContext)

  useEffect(() => {
    setVideoData(uiHelper(video));
    setVideoLink(video?.files[0])
  }, [video]);


  const editMutation = useMutation(
    videoData?.modifiedApi ? editRejectedExpertVideo : editExpertVideo,
    {

      onSuccess: () => {
        setOpenModal(false);
        return queryCilent.invalidateQueries({
          queryKey: ["contents"],
        });
      },
    }
  );

  const cancelUpdateMutation = useMutation(cancelModifiedVideoUpdate, {
    onSuccess: () => {
      return queryCilent.invalidateQueries({
        queryKey: ["contents"],
      });
    },
  });

  const onModalOk = () => {
    editMutation.mutate({
      body: {
        title: title,
        description: description,
        tag: tag,
        categoriesIds: categoriesIds,
        keywords: keywords.map((keyword) => keyword.value),
        files: newOldKeys,
        cover: newOldVideoCoverKey === ""
          ? newOldVideoCoverKey
          : videoData?.data?.cover,
        type: "VIDEO",
      },
      contentId: video?.id,
    });
  };

  const doEdit = () => {
    resetFileKeysContext();
    resetExpertVideosContext();
    resetUploadingProcessContext();
    setOpenModal(true);
  };

  const cancelUpdate = () => cancelUpdateMutation.mutate(video?.id);

  return (
    <div className="font-body relative w-[380px]  max-lg:w-full pb-2   bg-gray-50 rounded-2xl shadow flex-col justify-start items-center gap-2 inline-flex">
      <div className="flex-col justify-center items-center flex h-[215px] overflow-hidden ">
        
         {videoLink &&
          <video
          
            autoPlay={false}
            width={450} 
            
            controls
            poster={process.env.REACT_APP_ARVAN_S3_BASE_URL + videoData?.data?.cover}
            className=" max-lg:w-full h-full  rounded-t-2xl "
          >
            <source
            
              src={process.env.REACT_APP_ARVAN_S3_BASE_URL + videoLink}
              type="video/mp4"
            />
          </video>}
       
      </div>
      <div className="px-px justify-start items-center gap-[50px] inline-flex">
        <div className="flex flex-col ">
          <div className="text-ellipsis whitespace-nowrap max-lg:text-base text-center text-black text-lg font-semibold">
            {videoData?.data.title}
          </div>
        </div>
      </div>

      <div className="w-full flex flex-col gap-2  justify-evenly items-center ">
        <div className="flex flex-row w-full items-center justify-between px-3">
          <div
            className={`h-[27px] px-6 py-1 ${
              videoData?.data?.tag === "EDUCATIONAL_VIDEO"
                ? "bg-blue-600"
                : "bg-green-600"
            } rounded-xl justify-center items-center  flex`}
          >
            <div className="text-center whitespace-nowrap text-white text-xs font-black tracking-tight">
              {videoData?.data?.tag === "EDUCATIONAL_VIDEO"
                ? "ویدیو آموزشی"
                : "تجربه کشاورزان"}
            </div>
          </div>
          <div className=" h-[19px] text-center text-zinc-500 text-sm font-medium">
            {videoData?.data?.createdAt &&
              moment(videoData?.data?.createdAt, "YYYY/MM/DD")
                .locale("fa")
                .format("YYYY/MM/DD")}
          </div>
        </div>
        <div className="w-full">
          {videoData?.showEditBtn && (
            <Button
              className="text-xs w-11/12 mr-auto z-40"
              icon={<EditOutlined />}
              onClick={doEdit}
            >
              ویرایش محتوا
            </Button>
          )}
        </div>

        {/* action buttons */}
        <div className=" absolute max-lg:flex-col flex  bottom-4 z-40">
          {/* cancel and edit */}
          <>
            {videoData?.showCancelBtn && (
              <Button
                className="px-12 text-red-600 max-lg:m-auto :ml-auto"
                icon={<CloseOutlined />}
                onClick={cancelUpdate}
              >
                لغو بررسی
              </Button>
            )}
          </>
        </div>
      </div>

      {/* info texts */}
      {videoData?.showMaskLayer && (
        <div className="flex w-full flex-col max-lg:justify-center justify-start py-10 gap-3 bg-slate-200/80 absolute top-0 left-0 bottom-0 font-body rounded-xl z-30">
          {/* main info */}
          <p className="text-lg font-bold text-black">
            {videoData?.mainInfoText}
          </p>

          {/* detail info */}
          <p className="text-sm font-bold text-black">
            {videoData?.detailInfoText}
          </p>
        </div>
      )}

      {openModal && (
        <CustomModal
          size={modalSize}
          visible={openModal}
          handleCancel={() => setOpenModal(false)}
          onOk={onModalOk}
        >
          <ExpertVideoModal video={videoData?.data} />
        </CustomModal>
      )}
    </div>
  );
}

export default ExpertVideosSwiper;
